import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../shared/contexts/AuthContext";
import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Alert } from "antd";
import FormInput from "../../../shared/components/form/formInput/FormInput";
import hff_donors_logo_dark from "./../../../assets/images/hff_donors_logo_dark.png"
import { setPageTitle } from "../../../shared/utils/common";
import { AUTH_SERVICE } from '../../../shared/services/auth-service';
import "./ForgotPassword.scss"

const { Title, Text } = Typography;

const ForgotPassword: React.FC = () => {
  
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<'success' | 'error' | null>(null);



  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    setStatus(null);
    try {
      const response = await AUTH_SERVICE.forgotPassword('/api/crm/forgot-password', values.email);
      if (response?.success) {
        setStatus('success');
        form.resetFields();
      }
    } catch (error) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPageTitle("Forgot Password");
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f0f2f5",
      }}
      className="login-page"
    >
      <Flex vertical
        className="box-shadow-thin"
        style={{
          width: 500,
          padding: 30,
          backgroundColor: "#fff",
          margin: "10px"
        }}
      >
        <Flex justify="center" align="center" vertical>
          <img
            src={hff_donors_logo_dark}
            alt="HFF Donors"
            width={265}
          />
          <Title level={3} className="p-10" style={{ textAlign: "center", marginBottom: 20 }}>
            Forgot Password
          </Title>
        </Flex>
        {status === 'success' && (
          <Alert
            message="If your email is associated with HFF Donors, you will receive a password reset email shortly."
            type="success"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        {status === 'error' && (
          <Alert
            message="Something went wrong"
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        <Form name="loginForm" layout="vertical" onFinish={onFinish} requiredMark={false} form={form}>
          <Flex vertical gap={32}>
            <Flex vertical gap={18}>
              <Text style={{ fontWeight: "500" }}>Enter the email address associated with your HFF Donors account to receive password reset instructions.</Text>
              <FormInput
                label="Email"
                name="email"
                type="email"
                className="input-height"
                rules={[
                  { required: true, message: "Please input your email!" },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              />
            </Flex>

            <Form.Item>
              <Button
                className="input-height"
                type="primary"
                htmlType="submit"
                block
                loading={loading}
              >
                Request reset link
              </Button>
            </Form.Item>
          </Flex>
          <div style={{ textAlign: "center" }}>
            <Link to="/login">Back to login</Link>
          </div>
        </Form>
      </Flex>
    </div>
  );
};

export default ForgotPassword;
